import {useContext, useEffect} from "react";

import {NotificationsContext} from "@ui-components/Notifications";
import {DataContext} from "../DataContext/DataContext";
import apiRequest from "../apiRequest";

const useReasonTypes = () => {

  const {push} = useContext(NotificationsContext);
  const dataContext = useContext(DataContext);

  useEffect(() => {
    let closed = false;
    const fetchData = async () => {
      try {
        const data = await apiRequest.get(`/absences/reason-types`);
        if (!closed) {
          dataContext.setReasonTypes(data);
        }
      } catch (error) {
        console.log(error)
        dataContext.setReasonTypes(false);
        if (!closed) {
          push({
            title: "Errore durante il caricamento",
            type: "error",
          });
        }
      }
    };

   if (dataContext.reasonTypes === null) {
      fetchData();
    }

    return () => {
      closed = true;
    };
 }, [dataContext.reasonTypes]);  // eslint-disable-line react-hooks/exhaustive-deps

  if (!dataContext.reasonTypes) {
    return undefined
  }
  return dataContext.reasonTypes;

};

export default useReasonTypes;
